import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=1e2e4a95&"
import script from "./forgot-password.js?vue&type=script&lang=js&"
export * from "./forgot-password.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports